import { render, staticRenderFns } from "./ColaboradoresExt.vue?vue&type=template&id=a5d85136&"
import script from "./ColaboradoresExt.vue?vue&type=script&lang=js&"
export * from "./ColaboradoresExt.vue?vue&type=script&lang=js&"
import style0 from "./ColaboradoresExt.vue?vue&type=style&index=0&id=a5d85136&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports